import constants from '../constants/common';

const { ICON_SIZE, MIN_ICONS_QUANTITY } = constants;

const getColumnsAmount = (icons = [], containerWidth = 0) =>
  icons.length <= MIN_ICONS_QUANTITY ? parseInt(containerWidth / ICON_SIZE, 10) : 0;

export default getColumnsAmount;
